import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d7bc400"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center",
  style: {"width":"100%"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "answer-container" }
const _hoisted_5 = { class: "personal-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "回答者情報", -1))
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = {
  key: 0,
  class: "item-wrap"
}
const _hoisted_9 = {
  key: 1,
  class: "item-wrap"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "confirm-form"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "確認者名 ", -1))
const _hoisted_13 = {
  key: 1,
  class: "confirmed-box"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "確認済", -1))
const _hoisted_15 = { class: "date" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "question-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "回答内容", -1))
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "item-wrap item-wrap__note" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "その他、連絡事項", -1))
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "container" }
const _hoisted_29 = { class: "answer-complete-container" }
const _hoisted_30 = { class: "answer-personal-container" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "回答者情報", -1))
const _hoisted_32 = { class: "flex justify-between q-py-md q-pr-md" }
const _hoisted_33 = {
  key: 0,
  class: "item-wrap"
}
const _hoisted_34 = {
  key: 1,
  class: "item-wrap"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 0,
  class: "confirmed-box"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "確認済", -1))
const _hoisted_38 = { class: "date" }
const _hoisted_39 = { class: "name" }
const _hoisted_40 = { class: "answer-question-container" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "回答内容", -1))
const _hoisted_42 = { class: "q-pb-sm" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = {
  key: 2,
  style: {"color":"#999"}
}
const _hoisted_46 = { key: 3 }
const _hoisted_47 = { key: 4 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "item-wrap item-wrap__note" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "その他、連絡事項", -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 1,
  style: {"color":"#999"}
}

import { ref, reactive, computed } from 'vue'
import { useAsyncTask } from 'vue-concurrency'
import { Book, Sheet } from '@/models'
import { swalError } from '@/utils'
import api from '@/api'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  props: {
  answerHash: { type: String, requierd: true },
},
  setup(__props) {

const props = __props

const route = useRoute()

/* Bookデータ */
const book = ref(new Book())
/* Sheetデータ */
const sheet = ref(new Sheet())



const confirm = reactive({
  confirmName: '',
  answerHash: props.answerHash as string,
  confirmFlg: '1',
})

const sendConfirmData = () => {
  api.sheet.setConfirm(confirm).then(res => {
    location.reload()
  })
}

const getAnswerTask = useAsyncTask(async (signal, answerHash) => {
  if( route.name !== 'SheetResult' ) {
    // 通常の回答ページ
    return api.sheet
      .getAnswer({ cd: answerHash })
      .then(data => {
        // Bookデータを保持
        book.value = data.book
        // Formデータを保持
        sheet.value = data.sheet
      })
      .catch(err => {
        swalError.fire({ text: err ?? '送信できませんでした' })
      })
  } else {
    // 管理者用の回答ページ
    return api.sheet
      .getAnswerResult({ cd: answerHash, isLogin:true })
      .then(data => {
        // Bookデータを保持
        book.value = data.book
        // Formデータを保持
        sheet.value = data.sheet
      })
      .catch(err => {
        swalError.fire({ text: err ?? '送信できませんでした' })
      .then(data => {
        if( data.isConfirmed ) {
          location.href = "/"
        }
      })

      })
  }

})

getAnswerTask.perform(props.answerHash)

const displayedConfirmDt = computed(() => dayjs(sheet.value.confirmDt).format('YYYY/MM/DD'))

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.$q.screen.lt.sm ? 'width: 100%;' : 'min-width: 500px')
  }, [
    (_unref(getAnswerTask).isRunning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_spinner, {
            color: "grey",
            size: "5em"
          })
        ]))
      : (_unref(getAnswerTask).isError)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_unref(getAnswerTask).last?.error), 1)
          ], 64))
        : (_unref(getAnswerTask).lastSuccessful)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_unref(route).name !== 'SheetCompleted' && _unref(route).name !== 'SheetResult' )
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _hoisted_6,
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.personalAttr, (data, key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `data_${key}`
                                }, [
                                  (sheet.value.personalData[key] !== '' && key !== 'questionEmail')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createElementVNode("span", null, _toDisplayString(sheet.value.personalData[key]), 1)
                                      ]))
                                    : (sheet.value.personalData[key] !== '')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                          _createElementVNode("a", {
                                            href: `mailto:${sheet.value.personalData[key]}`
                                          }, _toDisplayString(sheet.value.personalData[key]), 9, _hoisted_10)
                                        ]))
                                      : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            (sheet.value.confirmFlg === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _hoisted_12,
                                  _createVNode(_component_q_input, {
                                    square: "",
                                    dense: "",
                                    outlined: "",
                                    modelValue: _unref(confirm).confirmName,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(confirm).confirmName) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_q_btn, {
                                    class: "q-mt-xs",
                                    onClick: sendConfirmData,
                                    style: {"width":"100%"},
                                    color: "primary",
                                    label: "確認"
                                  })
                                ]))
                              : (sheet.value.confirmFlg === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _hoisted_14,
                                    _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(displayedConfirmDt)), 1),
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(sheet.value.confirmName), 1)
                                  ]))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", {
                            style: _normalizeStyle(
                  _unref(route).name !== 'SheetCompleted' && _ctx.$q.screen.lt.sm
                    ? 'height: 250px; overflow-y: scroll'
                    : _unref(route).name !== 'SheetCompleted'
                    ? 'height: 430px; overflow-y: scroll'
                    : ''
                )
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.questions, (data, i) => {
                              return (_openBlock(), _createElementBlock("dl", {
                                key: `data_${i}`,
                                class: _normalizeClass([data.type === 'txb' || data.type === 'txt' ? 'item-wrap__note' : '', "item-wrap"])
                              }, [
                                (data.type !== 'lbl' && sheet.value.answers[i] !== null)
                                  ? (_openBlock(), _createElementBlock("dt", {
                                      key: 0,
                                      innerHTML: data.question
                                    }, null, 8, _hoisted_19))
                                  : _createCommentVNode("", true),
                                (data.type === 'lbl')
                                  ? (_openBlock(), _createElementBlock("dt", {
                                      key: 1,
                                      innerHTML: data.question,
                                      style: {"font-size":"11pt"}
                                    }, null, 8, _hoisted_20))
                                  : _createCommentVNode("", true),
                                (
                        (data.type === 'r02' && sheet.value.answers[i] !== null) ||
                        (data.type === 'r03' && sheet.value.answers[i] !== null)
                      )
                                  ? (_openBlock(), _createElementBlock("dd", _hoisted_21, _toDisplayString(sheet.value.answers[i] === '1'
                          ? data.qa
                          : sheet.value.answers[i] === '2'
                          ? data.qb
                          : sheet.value.answers[i] === '3'
                          ? data.qc
                          : sheet.value.answers[i] === '4'
                          ? data.qd
                          : sheet.value.answers[i] === '5'
                          ? data.qe
                          : ''), 1))
                                  : (data.type !== 'lbl' && sheet.value.answers[i] !== null)
                                    ? (_openBlock(), _createElementBlock("dd", _hoisted_22, [
                                        (data.prefix)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(data.prefix), 1))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(sheet.value.answers[i]) + " ", 1),
                                        (data.suffix)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(data.suffix), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                              ], 2))
                            }), 128)),
                            _createElementVNode("dl", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("dd", null, _toDisplayString(sheet.value.sheetNote), 1)
                            ])
                          ], 4)
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.personalAttr, (data, key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `data_${key}`
                                }, [
                                  (sheet.value.personalData[key] !== '' && key !== 'questionEmail')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createElementVNode("span", null, _toDisplayString(sheet.value.personalData[key]), 1)
                                      ]))
                                    : (sheet.value.personalData[key] !== '')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _createElementVNode("a", {
                                            href: `mailto:${sheet.value.personalData[key]}`
                                          }, _toDisplayString(sheet.value.personalData[key]), 9, _hoisted_35)
                                        ]))
                                      : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            (sheet.value.confirmFlg === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _hoisted_37,
                                  _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(displayedConfirmDt)), 1),
                                  _createElementVNode("p", _hoisted_39, _toDisplayString(sheet.value.confirmName), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.questions, (data, i) => {
                              return (_openBlock(), _createElementBlock("dl", {
                                key: `data_${i}`,
                                class: _normalizeClass([data.type === 'txb' || data.type === 'txt' ? 'item-wrap__note' : '', "item-wrap"])
                              }, [
                                (data.type !== 'lbl')
                                  ? (_openBlock(), _createElementBlock("dt", {
                                      key: 0,
                                      innerHTML: data.question
                                    }, null, 8, _hoisted_43))
                                  : _createCommentVNode("", true),
                                (data.type === 'lbl')
                                  ? (_openBlock(), _createElementBlock("dt", {
                                      key: 1,
                                      innerHTML: data.question,
                                      style: {"font-size":"11pt","padding":"10px","background-color":"rgb(224 243 242)"}
                                    }, null, 8, _hoisted_44))
                                  : (data.type !== 'lbl' && sheet.value.answers[i] === null)
                                    ? (_openBlock(), _createElementBlock("dd", _hoisted_45, "回答なし"))
                                    : (data.type === 'r02' || data.type === 'r03')
                                      ? (_openBlock(), _createElementBlock("dd", _hoisted_46, _toDisplayString(sheet.value.answers[i] === '1'
                          ? data.qa
                          : sheet.value.answers[i] === '2'
                          ? data.qb
                          : sheet.value.answers[i] === '3'
                          ? data.qc
                          : sheet.value.answers[i] === '4'
                          ? data.qd
                          : sheet.value.answers[i] === '5'
                          ? data.qe
                          : ''), 1))
                                      : (data.type !== 'lbl')
                                        ? (_openBlock(), _createElementBlock("dd", _hoisted_47, [
                                            (data.prefix)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(data.prefix), 1))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(sheet.value.answers[i]) + " ", 1),
                                            (data.suffix)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(data.suffix), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                              ], 2))
                            }), 128)),
                            _createElementVNode("dl", _hoisted_50, [
                              _hoisted_51,
                              (sheet.value.sheetNote !== null)
                                ? (_openBlock(), _createElementBlock("dd", _hoisted_52, _toDisplayString(sheet.value.sheetNote), 1))
                                : (_openBlock(), _createElementBlock("dd", _hoisted_53, "回答なし"))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
            ], 64))
          : _createCommentVNode("", true)
  ], 4))
}
}

})